<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="50"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Afhentningsoplysninger</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="contact-section" class="mobile-container bg-light">
            <div class="py-2 font-larger">
                <div class="row">
                    <div class="col-10">
                        <div class="mb-2">{{ booking.pickup_address.name }}</div>
                        <div class="mb-2">
                            {{ booking.pickup_address.street }},
                            {{ booking.pickup_address.zip }}
                            {{ booking.pickup_address.city }},
                            <span v-if="booking.pickup_address.country">{{ booking.pickup_address.country.name }}</span>
                        </div>
                        <div class="mb-2">{{ booking.pickup_address.phone }}</div>
                        <div>
                            <button class="btn btn-success" @click="goNext">Næste STEP</button>
                        </div>
                    </div>
                    <div class="col-2">
                        <span class="material-icons-outlined cursor-pointer text-primary"
                              title="Edit info"
                              @click="toggleModal('infoModal')"
                        >edit</span>
                    </div>

                </div>

            </div>
        </section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit pickup info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal('modal')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            En adresse ændring koster et gebyr på {{ calculatePriceWithVatAndRoundToNearestTens(configurations['change_address_pickup']['value']) }}kr.
                            Vi skal gøre opmærksom på at din afhentning vil blive skubbet minimum {{ configurations['days_autopush_pickup']['value'] }} dag(e) såfremt du ændrer afhentningsinformationerne nedenfor.
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="name" class="mb-0 font-weight-bold">Name</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newPickupAddress.name == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Name"
                                           id="name"
                                           v-model="newPickupAddress.name"
                                           @change="validate(false)"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
                            </div>
                            <div class="form-group">
                                <label for="street" class="mb-0 font-weight-bold">Street</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newPickupAddress.street == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Street"
                                           id="street"
                                           v-model="newPickupAddress.street"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.street">{{ errors.street }}</div>
                            </div>
                            <div class="form-group">
                                <label for="zip" class="mb-0 font-weight-bold">Zip</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newPickupAddress.zip == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Zip"
                                           id="zip"
                                           v-model="newPickupAddress.zip"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.zip">{{ errors.zip }}</div>
                            </div>
                            <div class="form-group">
                                <label for="city" class="mb-0 font-weight-bold">City</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newPickupAddress.city == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="City"
                                           id="city"
                                           v-model="newPickupAddress.city"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.city">{{ errors.city }}</div>
                            </div>
                            <div class="form-group">
                                <label for="phone" class="mb-0 font-weight-bold">Phone</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newPickupAddress.phone == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Phone"
                                           id="phone"
                                           v-model="newPickupAddress.phone"
                                           @change="validate(false)"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.phone">{{ errors.phone }}</div>
                            </div>

                            <button class="btn btn-primary mb-1"
                                    :disabled="Object.keys(this.errors).length > 0"
                                    @click="saveChanges">
                                Save
                            </button>
                            <div class="text-danger" v-if="errors.general">{{ errors.general }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            ref="infoModal"
            class="modal fade"
            :class="{show, 'd-block': activeInfoModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Bemærkning</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal('infoModal')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <span>Bemærk at du er ved at foretage ændringer i dine afhentningsoplysninger.</span>
                            <span v-if="configurations['change_address_pickup']['value'] > 0">
                                Adresseændring koster et gebyr på {{ calculatePriceWithVatAndRoundToNearestTens(configurations['change_address_pickup']['value']) }} kr.
                            </span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mb-1" @click="toggleModal('infoModal')">Afbryd</button>
                            <button class="btn btn-success mb-1"
                                    @click="toggleModal('infoModal'); toggleModal('modal');"
                            >Ok</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <back-section :url="prevUrl" type="1"></back-section>

        <modal-iframe ref="modal-iframe" @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"></modal-iframe>
        <div v-if="activeModalInterval || activeIframeModalInterval || activeInfoModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "../reusable/ProgressBar.vue";
import BackSection from "../reusable/BackSection.vue";
import ModalIframe from "../reusable/ModalIframe.vue";
import FlashError from "../reusable/FlashError.vue";
import priceMixin from "../../../mixins/priceMixin";
import dateTimeMixin from "../../../mixins/dateTimeMixin";
import customerSmsFlowMixin from "../../../mixins/customerSmsFlowMixin";
export default {
    name: "CmfPickupStep3",
    components: {FlashError, ModalIframe, ProgressBar, BackSection},
    mixins: [priceMixin, dateTimeMixin, customerSmsFlowMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        changeAddressKey: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        changeDeliveryInfoUrl: {type: String, required: true},
    },
    data() {
        return {
            activeModalInterval: false,
            activeIframeModalInterval: false,
            activeInfoModalInterval: false,
            additionalServices: {},
            errors: {},
            newPickupAddress: this.booking.pickup_address ?
                JSON.parse(JSON.stringify(this.booking.pickup_address)) :
                {},
            show: false,
            isSubmit: false,
        }
    },
    created() {


        if (this.additionalServicesProp[this.changeAddressKey]) {
            this.setAddressFromSession('newPickupAddress');
            this.setAddressFromSession();
        }
    },
    methods: {
        goNext() {
            window.location.href = this.nextUrl;
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        toggleModal(ref = 'modal') {
            const body = document.querySelector("body");
            if (ref === 'modal') {
                this.activeModalInterval = !this.activeModalInterval;
            } else {
                this.activeInfoModalInterval = !this.activeInfoModalInterval;
            }
            this.activeModalInterval || this.activeInfoModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);

            if (ref === 'modal' && !this.activeModalInterval) { // We close the modal without saving
                this.errors = {};
                if (this.additionalServicesProp[this.changeAddressKey]) {
                    this.setAddressFromSession('newPickupAddress');
                } else {
                    this.newPickupAddress = JSON.parse(JSON.stringify(this.booking.pickup_address));
                }
            }
        },
        setAddressFromSession(type = '') {
            if (type === 'newPickupAddress') {
                this.$set(this.newPickupAddress, 'name', this.additionalServicesProp[this.changeAddressKey]['value'].name);
                this.$set(this.newPickupAddress, 'street', this.additionalServicesProp[this.changeAddressKey]['value'].street);
                this.$set(this.newPickupAddress, 'city', this.additionalServicesProp[this.changeAddressKey]['value'].city);
                this.$set(this.newPickupAddress, 'zip', this.additionalServicesProp[this.changeAddressKey]['value'].zip);
                this.$set(this.newPickupAddress, 'phone', this.additionalServicesProp[this.changeAddressKey]['value'].phone);
            } else {
                this.$set(this.booking.pickup_address, 'name', this.additionalServicesProp[this.changeAddressKey]['value'].name);
                this.$set(this.booking.pickup_address, 'street', this.additionalServicesProp[this.changeAddressKey]['value'].street);
                this.$set(this.booking.pickup_address, 'city', this.additionalServicesProp[this.changeAddressKey]['value'].city);
                this.$set(this.booking.pickup_address, 'zip', this.additionalServicesProp[this.changeAddressKey]['value'].zip);
                this.$set(this.booking.pickup_address, 'phone', this.additionalServicesProp[this.changeAddressKey]['value'].phone);
            }
        },
        async saveChanges() {
            const validationResult = await this.validate();
            if (!validationResult) {
                return;
            }

            this.isSubmit = true;

            axios.patch( this.changeDeliveryInfoUrl, this.newPickupAddress)
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                    this.$set(this.booking, 'pickup_address', JSON.parse(JSON.stringify(this.newPickupAddress)));
                    setTimeout(() => {
                        this.toggleModal();
                    }, 1000);
                }).catch(error => {
                this.$refs.flashError.flashError(error);
                if (error.response.data && error.response.data.errors) {
                    for(let key in error.response.data.errors) {
                        this.$set(this.errors, key, error.response.data.errors[key][0])
                    }
                }
            }).finally(() => {
                this.isSubmit = false;
            });

        },
        validate(validateWithGoogleMaps = true) {
            return new Promise((resolve) => {
                this.errors = {};
                // Validation step 1
                let isValid = true;
                if (!this.newPickupAddress.zip) {
                    isValid = false;
                    this.$set(this.errors, 'zip', 'Zip is required');
                } else if (this.newPickupAddress.zip.length < 4) {
                    isValid = false;
                    this.$set(this.errors, 'zip', 'Invalid Zip ');
                }
                if (!this.newPickupAddress.street) {
                    isValid = false;
                    this.$set(this.errors, 'street', 'Address is required');
                } else if (this.newPickupAddress.street.length < 4) {
                    isValid = false;
                    this.$set(this.errors, 'street', 'Invalid Street ');
                }
                if (!this.newPickupAddress.city) {
                    isValid = false;
                    this.$set(this.errors, 'city', 'City is required');
                } else if (this.newPickupAddress.city.length < 2) {
                    isValid = false;
                    this.$set(this.errors, 'city', 'Invalid City ');
                }
                if (!this.newPickupAddress.name) {
                    isValid = false;
                    this.$set(this.errors, 'name', 'Name is required');
                }
                if (!this.newPickupAddress.phone) {
                    isValid = false;
                    this.$set(this.errors, 'phone', 'Phone is required');
                } else if (this.newPickupAddress.phone.length < 6) {
                    isValid = false;
                    this.$set(this.errors, 'phone', 'Invalid phone ');
                }

                if (!this.errors['zip'] &&
                    (this.booking.pickup_address.zip < 5000 && this.newPickupAddress.zip > 5000) ||
                    (this.booking.pickup_address.zip > 5000 && this.newPickupAddress.zip < 5000)) {
                    isValid = false;
                    this.errors['zip'] = 'Det er ikke muligt at skifte til et postnummer på den anden side af Storebæltsbroen.';
                }

                if (!isValid) {
                    resolve(false);
                    return;
                } else if(!validateWithGoogleMaps) {
                    resolve(true);
                    return;
                }

                // Validation step 2
                const regionCode = this.booking.pickup_address.country.code ? this.booking.pickup_address.country.code : 'DK';
                let address = {};
                if (this.booking.pickup_address.country && this.booking.pickup_address.country.code) {
                    address.regionCode = this.booking.pickup_address.country.code;
                }

                axios.post(`https://addressvalidation.googleapis.com/v1:validateAddress?key=AIzaSyDSSw89RnoedD7ChwJE6p2ACQ3GfMDqS1A`, {
                        "address": {
                            "regionCode": regionCode,
                            "postalCode": this.newPickupAddress.zip,
                            "addressLines": [`${this.newPickupAddress.street}, ${this.newPickupAddress.city}`]
                        },
                    }
                ).then((response) => {
                    console.log(response.data.result);
                    if (['ROUTE', 'OTHER'].includes(response.data.result.verdict.validationGranularity) ||
                        !response.data.result.verdict.addressComplete
                    ) {
                        this.$set(this.errors, 'general', "There isn't enough information for the delivery. Or some information isn't valid" );
                        resolve(false);
                    } else {
                        let postalAddress = response.data.result.address.postalAddress;
                        console.log(postalAddress);
                        if (!postalAddress.postalCode || postalAddress.postalCode != this.newPickupAddress.zip) {
                            console.log('Invalid zip');
                            if (postalAddress.postalCode) {
                                this.$set(this.errors, 'zip', `Did you mean this one: ${postalAddress.postalCode}?`);
                            }
                            isValid = false;
                        } else if(!postalAddress.locality || postalAddress.locality !== this.newPickupAddress.city) {
                            console.log('Invalid city');
                            if (postalAddress.locality) {
                                this.$set(this.errors, 'city', `Did you mean this one: ${postalAddress.locality}?`);
                            }
                            isValid = false;
                        } else if(!postalAddress.addressLines || !postalAddress.addressLines[0] || postalAddress.addressLines[0] !== this.newPickupAddress.street) {
                            console.log('Invalid street');
                            let message = '';
                            if (postalAddress.addressLines || postalAddress.addressLines[0]) {
                                message = `Did you mean this one: ${postalAddress.addressLines[0]}?`
                            }
                            this.$set(this.errors, 'street', `Invalid Street. ${message}`);
                            isValid = false;
                        } else if(!postalAddress.regionCode || postalAddress.regionCode !== 'DK') {
                            console.log('Invalid country');
                            isValid = false;
                        }

                        if (isValid) {
                            // Validation step 3
                            console.log(response.data.result.geocode.placeId);
                            axios.get(`https://places.googleapis.com/v1/places/${response.data.result.geocode.placeId}?key=AIzaSyDSSw89RnoedD7ChwJE6p2ACQ3GfMDqS1A&fields=addressComponents`)
                                .then((res) => {
                                    console.log(res.data.addressComponents);
                                    for (let i = 0; i < res.data.addressComponents.length; i++) {
                                        if (res.data.addressComponents[i].types.includes('locality') &&
                                            res.data.addressComponents[i].longText !== this.newPickupAddress.city &&
                                            res.data.addressComponents[i].shortText !== this.newPickupAddress.city
                                        ) {
                                            this.$set(this.errors, 'general', 'Invalid delivery info' );
                                            this.$set(this.errors, 'city', `Did you mean this one: ${res.data.addressComponents[i].longText}?` );
                                            isValid = false;
                                        }
                                        if (res.data.addressComponents[i].types.includes('postal_code') &&
                                            res.data.addressComponents[i].longText !== this.newPickupAddress.zip &&
                                            res.data.addressComponents[i].shortText !== this.newPickupAddress.zip
                                        ) {
                                            this.$set(this.errors, 'general', 'Invalid delivery info' );
                                            this.$set(this.errors, 'zip', `Did you mean this one: ${res.data.addressComponents[i].longText}?` );
                                            isValid = false;
                                        }
                                    }
                                })
                                .catch((error) => {
                                    this.$set(this.errors, 'general', 'Google maps error' );
                                    console.error(error);
                                    isValid = false;
                                });
                            if (isValid) {
                                resolve(true);
                            }
                        } else {
                            this.$set(this.errors, 'general', "There isn't enough information for the delivery. Or some information isn't valid" );
                            resolve(false);
                        }

                    }
                }).catch((error) => {
                    this.$set(this.errors, 'general', 'Google maps error' );
                    console.error(error);
                    resolve(false);
                });
            })
        },
    },
}

</script>

<style scoped>

</style>
